module.exports = __webpack_public_path__ + "img/word.d4bd8782.png";